"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactGoogleMaps = require("react-google-maps");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var MarkerLocator = function MarkerLocator(_ref) {
  var coordinates = _ref.coordinates,
      renderMap = _ref.renderMap;

  _react["default"].useEffect(function () {
    renderMap(new window.google.maps.Geocoder());
  }, []);

  if (!coordinates.length) return null;
  return /*#__PURE__*/_react["default"].createElement(_reactGoogleMaps.GoogleMap, {
    defaultZoom: 12,
    defaultCenter: coordinates[0]
  }, coordinates.map(function (obj, i) {
    return /*#__PURE__*/_react["default"].createElement(_reactGoogleMaps.Marker, {
      key: i,
      position: {
        lat: obj.lat,
        lng: obj.lng
      }
    });
  }));
};

MarkerLocator.propTypes = {
  renderMap: _propTypes["default"].func.isRequired,
  coordinates: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    lng: _propTypes["default"].number,
    lat: _propTypes["default"].number
  })).isRequired
};
var Wrapped = (0, _reactGoogleMaps.withScriptjs)((0, _reactGoogleMaps.withGoogleMap)(MarkerLocator));

var Compass = function Compass(_ref2) {
  var apiKey = _ref2.apiKey,
      street = _ref2.street,
      city = _ref2.city,
      postal = _ref2.postal,
      rest = _objectWithoutProperties(_ref2, ["apiKey", "street", "city", "postal"]);

  var _React$useState = _react["default"].useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      coordinates = _React$useState2[0],
      setCoordinates = _React$useState2[1];

  var renderMap = function renderMap(google) {
    var address = "".concat(street, ", ").concat(city, ", ").concat(postal);
    google.geocode({
      'address': address
    }, function (results, status) {
      if (status === 'OK') {
        setCoordinates([{
          lng: results[0].geometry.location.lng(),
          lat: results[0].geometry.location.lat()
        }]);
      }
    });
  };

  return /*#__PURE__*/_react["default"].createElement(Wrapped, _extends({}, rest, {
    mapElement: /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        height: '100%'
      }
    }),
    loadingElement: /*#__PURE__*/_react["default"].createElement("div", null),
    googleMapURL: "https://maps.googleapis.com/maps/api/js?v=3.exp&key=".concat(apiKey, "&libraries=geometry,drawing,places "),
    coordinates: coordinates,
    renderMap: renderMap,
    containerElement: /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        height: '100%',
        width: '100%'
      }
    })
  }));
};

Compass.propTypes = {
  apiKey: _propTypes["default"].string.isRequired,
  street: _propTypes["default"].string.isRequired,
  city: _propTypes["default"].string.isRequired,
  postal: _propTypes["default"].string.isRequired
};
Compass.defaultProps = {};
var _default = Compass;
exports["default"] = _default;